export const DEACTIVATION_STAGES = {
  CHOICE: 'CHOICE',
  REASON: 'REASON',
  CONFIRM: 'CONFIRM',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
} as const;

export type DeactivationStage = (typeof DEACTIVATION_STAGES)[keyof typeof DEACTIVATION_STAGES];
